import Plugin from "../core/plugins";
import { PluginDescription } from "../core/plugins/plugin-description";
import { OpenAIMessage, Parameters } from "../core/chat/types";
import { maxTokensByModel } from "../core/chat/openai";
import { countTokens, runChatTrimmer } from "../core/tokenizer/wrapper";
import { HARDCODED_VALUES } from "../hardcoded-values";

export interface ContextTrimmerPluginOptions {
    maxTokens: number;
    maxMessages: number | null;
    preserveSystemPrompt: boolean;
    preserveFirstUserMessage: boolean;
}

export class ContextTrimmerPlugin extends Plugin<ContextTrimmerPluginOptions> {
    describe(): PluginDescription {
        return {
            id: "context-trimmer",
            name: "Message Context",
            options: [
                // All options removed - now using hardcoded values
            ],
        };
    }

    async preprocessModelInput(messages: OpenAIMessage[], parameters: Parameters): Promise<{ messages: OpenAIMessage[]; parameters: Parameters; }> {
        const before = await countTokens(messages);

        // Debug logging to see what's causing the massive token count
        console.log(`[DEBUG] Messages count: ${messages.length}`);
        console.log(`[DEBUG] Total tokens before trimming: ${before}`);
        console.log(`[DEBUG] Max tokens limit: ${HARDCODED_VALUES.contextTrimmer.maxTokens}`);
        
        // Log token count for each message
        for (let i = 0; i < Math.min(messages.length, 5); i++) {
            const msg = messages[i];
            const tokens = await countTokens([msg]);
            console.log(`[DEBUG] Message ${i} (${msg.role}): ${tokens} tokens, ${msg.content.length} chars`);
        }

        // Using hardcoded values instead of options
        const trimmed = await runChatTrimmer(messages, {
            maxTokens: HARDCODED_VALUES.contextTrimmer.maxTokens,
            nMostRecentMessages: undefined, // Disabled - keep all messages
            preserveFirstUserMessage: true, // Not configurable in hardcoded values 
            preserveSystemPrompt: HARDCODED_VALUES.contextTrimmer.preserveSystemPrompt,
        });

        const after = await countTokens(trimmed);

        const diff = after - before;
        console.log(`[context trimmer] trimmed ${diff} tokens from context`);
        console.log(`[DEBUG] Total tokens after trimming: ${after}`);

        return {
            messages: trimmed,
            parameters,
        };
    }
}